// 正式

module.exports = {
  title: 'prod',
  // 生产环境
  baseApi: '//fin-tag.id',
};
